import { all } from 'redux-saga/effects';

import { watchUser } from 'modules/user/sagas';
import { watchCompanies } from 'modules/companies/sagas';
import { watchArtworks } from 'modules/artworks/sagas';
import { watchArtwork } from 'modules/artwork/sagas';
import { watchErrors } from 'modules/errors/sagas';

export default function* rootSaga() {
  yield all([watchUser(), watchCompanies(), watchArtworks(), watchArtwork(), watchErrors()]);
}
